<section>
    <!-- Main Page Heading (Screen Reader Only) -->
    <h1 class="sr-only">User Management</h1>
  
    <div class="d-flex">
      <div class="d-grid gap-2 user-management-heading">
        <!-- Visual Heading for Users -->
        <h3>User Management</h3>
        <!-- Optional SR-Only Secondary Description -->
        <h3 class="sr-only">User Management Page</h3>
      </div>
      <div class="gap-2 d-md-flex justify-content-end" style="margin-inline-start: auto; height:fit-content;margin-right: 15px;margin-top: 10px;">
        <eg-button type="button" className="btn-primary btn-font-family" iconName="fa-solid fa-plus"
          label="Add User" (click)="openDialog('add','')"></eg-button>
      </div>
    </div>
  
    <div class="search-container">
      <div class="search-bar">
        <i class="fa-solid fa-magnifying-glass search-icon" aria-hidden="true"></i>
        <input
          type="text"
          [(ngModel)]="searchText"
          (input)="onSearch($event)"
          placeholder="Search users..."
          aria-label="Search users"
        />
        <button *ngIf="searchText" class="clear-btn" (click)="clearSearch()" aria-label="Clear search">
          <i class="fa-solid fa-circle-xmark"></i>
        </button>
      </div>
    </div>
    <div class="user-container" *ngIf="!isLoading">
      <app-eg-table
        *ngIf="!isLoading && usersListCopy && usersListCopy?.length > 0"
        [data]="usersListCopy" [start]="start" [end]="end" [pageSize]="pageSize"
        [totalElements]="totalElements" [pageIndex]="pageIndex"
        [columns]="displayedColumns" [columnKeyValues]="cols" [serverSidePagination]="true"
        [multiselectcheckbox]="false"
        (pageEvent)="getChangedUsersList($event)" (btnClicked)="performUserOperations($event)"
        [showSortIcon]="false">
        <!-- Table caption for screen readers -->
        <caption class="sr-only">List of users with pagination and actions</caption>
      </app-eg-table>
      <div class="no-users-container" *ngIf="!isLoading && usersListCopy?.length === 0">
        <p>No users to display.</p>
      </div>
    </div>
    <div class="overlay" *ngIf="isLoading"></div>
    <div class="d-flex justify-content-center" *ngIf="isLoading">
      <div class="spinner-border loading-indicator" style="color: #2730E3;width: 3rem; height: 3rem;" role="status" aria-live="polite">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </section>
  